import { createProxyClient } from '../api/createProxyClient';

/**
 * Events-API-Client. Immer ueber den BFF-Proxy `/proxy/events/...`. Der BFF
 * injiziert server-seitig das GATEWAY_SHARED_SECRET (events-api hat
 * gateway-guard). Kein Operator-Bearer noetig.
 *
 * Nutzt jetzt die gemeinsame createProxyClient-Fabrik (#116).
 */
const client = createProxyClient('events');

export const eventsFetch = client.fetch;
export const isEventsProxyEnabled = client.isEnabled;
